/** Preserve measured zero; refuse partial numbers, coercion and negative measurements. */
export function parseOptionalClinicalMeasurement(value: unknown, label: string): number | null {
  if (value == null || (typeof value === 'string' && value.trim() === '')) return null;
  if (typeof value !== 'number' && typeof value !== 'string') {
    throw new Error(`${label} must be a number of zero or more.`);
  }
  if (typeof value === 'string' && !/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(value.trim())) {
    throw new Error(`${label} must be a number of zero or more.`);
  }
  const parsed = typeof value === 'number' ? value : Number(value.trim());
  if (!Number.isFinite(parsed) || parsed < 0)
    throw new Error(`${label} must be a number of zero or more.`);
  return parsed;
}
